import { render, staticRenderFns } from "./legislationService.vue?vue&type=template&id=5af5ae40&scoped=true"
import script from "./legislationService.vue?vue&type=script&lang=js"
export * from "./legislationService.vue?vue&type=script&lang=js"
import style0 from "./legislationService.vue?vue&type=style&index=0&id=5af5ae40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5ae40",
  null
  
)

export default component.exports